import Marquee from "react-fast-marquee";

const phrases = [
  "THROUGH ADVERSITY COMES CHANGE",
  "HEAL BEFORE THE SHIFT",
  "CORPORATE RESILIENCE",
  "WORK HARD · REST HARDER",
  "THE WEIGHT WE CARRY",
];

export default function EditorialMarquee() {
  return (
    <section className="relative border-y border-[#E7DFD5] py-8 md:py-10 overflow-hidden bg-[#FAF7F2]">
      <div className="marquee-fade">
        <Marquee gradient={false} speed={26} pauseOnHover>
          {phrases.concat(phrases).map((p, i) => (
            <span key={`${p}-${i}`} className="tacc-marquee-item text-4xl md:text-6xl lg:text-7xl px-10 md:px-16 text-[#44403C]">
              {p}
              <span className="text-[#B45309] mx-8">✦</span>
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
